const config = require('../../json/couponplatz.config.json');
const Card = require('./Card');
const nanoajax = require('nanoajax');

let CardList = function(remote_url = config.cardsUrl) {
	var self = this;
	self.cards = [];
	self.acceptors = [];
	var getData = () => {
		"use strict";
		function processData(code, response) {
			console.log("ajax call returned code " + code);
			let data, tempArray = [];
			switch (code) {
			case 200:
				data = JSON.parse(response);
				if (!Array.isArray(data.cards)) return;
				data.cards.forEach((item) => {
					if (item.type === 1) {
						tempArray.push(new Card(item));
					}
				});
				self.cards.splice(0, self.cards.length, ...tempArray);
				// alternative implementation for the line above:
				// let spliceArgs = [0, self.cards.length].concat(tempArray);
				// self.cards.splice.apply(self.cards, spliceArgs);
				break;
			default:
				data = require('../../json/content.json'); // mock data
				if (!Array.isArray(data.cards)) return;
				data.cards.forEach((item) => {
					if (item.type === 1) {
						tempArray.push(new Card(item));
					}
				});
				self.cards.splice(0, self.cards.length, ...tempArray);
			}
		}
		try {
			nanoajax.ajax({ url: remote_url }, processData);
		}
		catch (e) {
			console.log("ajax failed:");
			console.error(e);
		}
	};
	self.getCards = () => {
		"use strict";
		return self.cards;
	};
	self.getAcceptors = () => {
		"use strict";
		return self.acceptors;
	};
	let init = () => {
		"use strict";
		getData();
	};
	init();
};

module.exports = CardList;



// WEBPACK FOOTER //
// ./src/assets/js/domain/CardList.js